import React, { useState } from 'react';
import SimpleForm from './SimpleForm';
import './App.css';

const App = (props) => {
  let [showChat, setShowChat] = useState(true);

  const startChat = () => { setShowChat(true); }
  const hideChat = () => { setShowChat(false); }

    return (
      <>
      <div className = "header">
        <h2>Covid-19</h2>
      </div>

      <div className = "main">

        <div className ="content">
          <div style = {{padding:"20px"}}>
            <h1>Chat Bot</h1>
            <p> Il Chat bot fornisce informazioni ricavate dai <a href="https://github.com/pcm-dpc/COVID-19" target="_blank" >Dati COVID-19 Italia</a>, Open Data raccolti e pubblicati dal Dipartimento della Protezione Civile. </p>
            <p>Attualmente sono disponibili le informazioni sull'Andamento nazionale relativi all'ultima data di pubblicazione.</p>
            <p>Puoi interagire con il Chat bot, chiedendo ad esempio:</p>
            <ul>
              <li>Quanti sono i casi totali?</li>
              <li>Ci sono ricoverati in ospedale?</li>
              <li>Quanti sono i dimessi in Sardegna?</li>
              <li>Quanti sono i casi totali a Cagliari?</li>
            </ul>
          </div>
        </div>
      </div>
      <div className = "footer">Copyright &copy; 2020 <a href="mailto:cristian.lai@gmail.com,clai@crs4.it">Cristian Lai</a> | All Rights Reserved | This template is made with <i class="icon-heart" aria-hidden="true"></i> <a href="https://github.com/kumardh/react-chatbot" target="_blank" >React Simple Chatbot</a></div>

      <div className = "bot">
        <div style ={{display: showChat ? "" : "none"}}>
          <SimpleForm></SimpleForm>
        </div>
        {/* <div> {showChat ? <SimpleForm></SimpleForm> : null} </div> */}
        <div>
          {!showChat
            ? <button className="btn" onClick={() => startChat()}>Apri il chatbot</button>
            : <button className="btn" onClick={() => hideChat()}>Chiudi il chatbot</button>}
        </div>
      </div>
      </>
    )
}

export default App;
